import { createContext, useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";

import { getShortIdData } from '../utils/Common'

const SignUpContext = createContext();

export const SignUpProvider = ({ children }) => {
  const [loader, setLoader] = useState(false)
  const [isRegistered, setIsRegistered] = useState(false)
  const params = useParams();
  const [formData_1, setFormData_1] = useState({
    email: '',
    firstname: '',
    lastname: '',
    password: '',
    code: '',
    company_id: '',
    company_name: '',
    industry: '',
    company_size: '',
    role: '',
    domain_name: '',
    hear_about: '',
    module: ['chat'],
    emails: [''],
    team_title: [''],
  });

  const validateEmail = (email) => {
    const regex = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
    return regex.test(email);
  };

  const isValidUUID = (id) => {
    const uuidV4Regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidV4Regex.test(id);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getShortIdData(params.short_url);
        if (result.status) {
          if (
            isValidUUID(result.data?.company_id) &&
            validateEmail(result.data?.email)
          ) {
            setFormData_1((prevData) => ({
              ...prevData,
              email: result.data?.email,
              company_id: result.data?.company_id,
            }));
          }
        }
      } catch (err) {
        console.log("🚀 ~ fetchData ~ err.message:", err.message);
      } finally {
        // setLoading(false);
      }
    };

    if (params.short_url) {
      fetchData();
    }
  }, [params.short_url]); // track only the short_url string


  useEffect(() => {
    console.log(formData_1);
  }, [formData_1]);

  const [verifyCode, setVerifyCode] = useState({
    digit_1: '',
    digit_2: '',
    digit_3: '',
    digit_4: '',
    digit_5: '',
    digit_6: ''
  });

  return (
    <SignUpContext.Provider value={{ loader, setLoader, formData_1, setFormData_1, verifyCode, setVerifyCode, isRegistered, setIsRegistered }}>
      {children}
    </SignUpContext.Provider>
  );
};

export const useSignUp = () => {
  return useContext(SignUpContext);
};
